<template>
  <div class="wrapper">
    <div v-if="URL">
      <pdf :page="pageNum" :src="URL" @progress="loadedRatio = $event" @num-pages="pageTotalNum = $event" />
      <div class="pdfBottom">
        <span class="pdf-span">{{ pageNum }}</span>
        <span>/</span>
        <span> {{ pageTotalNum }}</span>
        <div class="button" v-if="pageTotalNum >= 1">
          <el-button plain @click="nextPage" v-if="pageTotalNum > 1">上一页</el-button>
          <el-button plain @click="prePage" v-if="pageTotalNum > 1">下一页</el-button>
        </div>
      </div>
    </div>
    <!-- <div v-else>文件异常！</div> -->
  </div>
</template>

<script>
import utils from '@/common/utils'
import pdf from "vue-pdf";
import {
  BusinessAuthorityGeneratePdf
} from '@/api/channel'
export default {
  components: {
    pdf
  },
  props: {
    URL: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      pageNum: 1, //当前页
      pageTotalNum: 1, //默认总页数

    }
  },
  created() { },
  mounted() {
  },
  activated() { },
  updated() { },
  methods: {
    //上一页
    prePage() {
      let page = this.pageNum;
      page = page > 1 ? page - 1 : this.pageTotalNum;
      this.pageNum = page;
    },
    //下一页
    nextPage() {
      let page = this.pageNum;
      page = page < this.pageTotalNum ? page + 1 : 1;
      this.pageNum = page;
    },
  },
  computed: {

  },
  watch: {
    // '$route': {
    //   handler(to, from) {
    //     console.log(to, 'to');
    //     this.ORCode(to.query.BAMID)
    //   },
    //   deep: true,
    //   immediate: true
    // }
  },
}
</script>
<style scoped lang='less'>
.wrapper {
  //   width: 100vw;
  //   height: 100vh;

  .pdfBottom {
    width: 90%;
    margin: 0 auto;
    line-height: 50px;
  }
  .button {
    float: right;
  }
}
</style>